<template>
      <div class="app-progress-area bg-black ptb-100 mob-hide">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="app-progress-animation-image"><img src="../../assets/images/Partner01.png"
                            alt="app-progress" data-aos="fade-down" data-aos-duration="1000"
                            class="aos-init aos-animate">
                            <img
                            src="../../assets/images/Partner02.png"
                            alt="app-progress" data-aos="fade-right" data-aos-duration="1000"
                            class="aos-init aos-animate"><img src="../../assets/images/Partner03.png"
                            alt="app-progress" data-aos="fade-left" data-aos-duration="1000" class="aos-init"><img
                            src="../../assets/images/Partner04.png" alt="app-progress" data-aos="fade-up"
                            data-aos-duration="1000" class="aos-init"><img src="../../assets/images/partner05.png"
                            class="main-image" alt="app-progress"></div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="app-progress-content text-white"><span class="sub-title">Why Partner</span>
                        <h2>Why Partner with Meander?</h2>
                        <p>We’re more than a technology provider, we’re a trusted innovation partner. With over a decade of experience, ISO 20000-1:2018 certification, and recognition from NASSCOM and industry leaders, Meander brings:</p>
                        <p><strong>Proven Expertise:</strong> End-to-end development from concept to deployment</p>
                        <p><strong>AI-Driven Innovation:</strong> Smart features, automation, and predictive analytics built into our solutions.</p>
                        <p><strong>Scalable Solutions: </strong>Cloud-ready and enterprise-grade technology that grows with your business.</p>
                         <p><strong>Global Reach: </strong>Serving diverse industries across multiple regions.</p>
                        <div :class="`others-opti  d-block `"
                                    v-if="!active">
                                    <button class="default-btn ms-2 partner-ct" @click="openPopup()">Contact</button>

                      
                    </div>


                        </div>
                </div>
            </div>
        </div>
    </div>






</template>

<style>
@media screen and (max-width: 767px) {
  .mob-hide .app-progress-animation-image {
    display: none;
}
    .mob-hide p {
    text-align: center;
}
.partner-ct {
    padding: 12px 40px !important;
}
.inner-banner h1.text-white::after {
        z-index: -1;
}
}
</style>
<script>
export default {
    name: 'WhyPartner',
      props: {
        openPopup: Function
    },
    
}
</script>


